<template>
  <div>
    <v-autocomplete
      v-model="selectedStaff"
      @input="$emit('change', selectedStaff)"
      item-text="name"
      item-value="id"
      dense
      filled
      outlined
      small-chips
      solo
      rounded
      :label="label"
      :items="staff"
    >
      <template v-slot:selection="data">
        <v-chip v-bind="data.attrs" :input-value="data.selected">
          <v-avatar left>
            <v-img :src="data.item.avatar"></v-img>
          </v-avatar>
          {{ data.item.name }}
        </v-chip>
      </template>
      <template v-slot:item="data">
        <v-list-item-avatar>
          <img :src="data.item.avatar" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-html="data.item.name"></v-list-item-title>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { decodeId } from "@/lib/string";
import { getUserName } from "@/lib/username";
import { STAFF_QUERY } from "@/graphql/queries/user";

export default {
  name: "StaffPicker",
  props: {
    label: {
      type: String,
      default: "Coach",
    },
    selected: {
      type: [Number, String],
      required: false,
    },
  },
  data() {
    return {
      staff: [],
      selectedStaff: this.selected,
    };
  },
  apollo: {
    users: {
      query: STAFF_QUERY,
      variables() {
        return {
          isActive: true,
          isStaff: true,
        };
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data && !response.loading) {
          this.staff = [];

          response.data.users.edges.forEach((item) => {
            let data = {
              id: decodeId(item.node.id),
              name: getUserName(item.node),
              avatar: item.node.userProfile?.profilePicture,
            };

            this.staff.push(data);
          });

          this.staff.sort((a, b) => (a.text > b.text ? 1 : -1));
        }
      },
    },
  },
};
</script>
